export default "__VITE_ASSET__D77V46M4__"